import httpClient from "@/utils/httpClient";
import type { ApiHeaders, ApiPayload } from "@/types/api";

export const loginService = {
  login: async <Response = unknown>(data: ApiPayload, headers: ApiHeaders = {}) =>
    httpClient.post<Response>("/login", data, { headers }),
  logout: async <Response = unknown>() => httpClient.post<Response>("/logout"),
  userInfo: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/login/userInfo", data),
  sendOtp: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/login/otp", data),
  checkOtp: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/login/otp/check", data),
  register: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/login/corporateApplication", data),
  warmup: async <Response = unknown>() => httpClient.get<Response>("/login/warmUp"),
  getSecurityImages: async <Response = unknown>() =>
    httpClient.get<Response>("/login/getSecurityImages"),
  insertSecurityImages: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/login/insertSecurityImages", data),
  getSecurityUserImage: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/login/getSecurityUserImage", data),
};
